<template>
  <div class="example-wide-image">
    <div v-show="$refs.uploadWide && $refs.uploadWide.dropActive" class="drop-active">
      <h3>{{ $t('common.imageUpload.drop') }}</h3>
    </div>
    <div class="wide-image-upload" v-show="!editWide">
      <div class="text-center p-2">
        <label for="wide-image">
          <img
            :src="filesWide.length ? filesWide[0].url : defaultImage"
            class="center"
            style="width: 200px"
          />
        </label>
      </div>
      <div class="text-center p-2">
        <file-upload
          extensions="gif,jpg,jpeg,png,webp"
          accept="image/png,image/gif,image/jpeg,image/webp"
          name="wide-image"
          class="btn btn-primary"
          :post-action="apiUrl"
          :headers="authHeaderValue"
          :drop="!editWide"
          v-model="filesWide"
          @input-filter="inputFilter"
          @input-file="inputFile"
          ref="uploadWide"
        >
          {{ $t('common.imageUpload.upload') }}
        </file-upload>
      </div>
    </div>

    <div class="wide-image-edit" v-show="filesWide.length && editWide">
      <div class="wide-image-edit-image" v-if="filesWide.length">
        <img ref="editImageWide" :src="filesWide[0].url" />
      </div>
      <div class="text-center p-4">
        <button
          type="button"
          class="btn btn-secondary"
          @click.prevent="$refs.uploadWide.clear"
        >
          {{ $t('common.cancel') }}
        </button>
        <button type="submit" class="btn btn-primary" @click.prevent="editSave">
          {{ $t('common.save') }}
        </button>
      </div>
    </div>
  </div>
  <!-- BEGIN: Failed Notification Content -->
  <div id="failed-image-content" class="toastify-content hidden flex">
    <XCircleIcon class="text-theme-6" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ $t('common.imageUpload.unsuported') }}</div>
    </div>
  </div>
  <!-- END: Failed Notification Content -->
</template>
<style>
.example-wide-image .wide-image-upload .rounded-circle {
  width: 200px;
  height: 200px;
}
.example-wide-image .text-center .btn {
  margin: 0 0.5rem;
}
.example-wide-image .wide-image-edit-image {
  max-width: 100%;
}

.example-wide-image .drop-active {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  position: fixed;
  z-index: 9999;
  opacity: 0.6;
  text-align: center;
  background: #000;
}

.example-wide-image .drop-active h3 {
  margin: -0.5em 0 0;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  font-size: 40px;
  color: #fff;
  padding: 0;
}
</style>

<script>
import Cropper from 'cropperjs'
import FileUpload from 'vue-upload-component'
import Toastify from 'toastify-js'
import 'cropperjs/dist/cropper.css'
import { defineComponent } from 'vue'
import authHeader from '@/services/security/auth.header'

export default defineComponent({
  components: {
    FileUpload
  },

  data() {
    return {
      filesWide: [],
      editWide: false,
      cropperWide: false
    }
  },

  watch: {
    filesWide(value) {
      if (value) {
        this.$nextTick(function () {
          if (!this.$refs.editImageWide) {
            return
          }
          this.cropperWide = new Cropper(this.$refs.editImageWide, {
            aspectRatio: this.aspectRatio,
            viewMode: 1
          })
        })
      } else {
        if (this.cropperWide) {
          this.cropperWide.destroy()
          this.cropperWide = false
        }
      }
    }
  },

  methods: {
    editSave() {
      this.editWide = false

      const oldFile = this.filesWide[0]

      const binStr = atob(
        this.cropperWide.getCroppedCanvas().toDataURL(oldFile.type).split(',')[1]
      )
      const arr = new Uint8Array(binStr.length)
      for (let i = 0; i < binStr.length; i++) {
        arr[i] = binStr.charCodeAt(i)
      }

      const file = new File([arr], oldFile.name, { type: oldFile.type })

      this.$refs.uploadWide.update(oldFile.id, {
        file,
        type: file.type,
        size: file.size,
        active: true
      })
    },

    inputFile(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        this.$nextTick(function () {
          this.editWide = true
        })
      }
      if (!newFile && oldFile) {
        this.editWide = false
      }
    },

    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (!/\.(gif|jpg|jpeg|png|webp)$/i.test(newFile.name)) {
          console.info(newFile.name)
          Toastify({
            node: cash('#failed-image-content').clone().removeClass('hidden')[0],
            duration: 10000,
            newWindow: true,
            close: true,
            gravity: 'top',
            position: 'right',
            stopOnFocus: true
          }).showToast()
          return prevent()
        }
      }

      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        newFile.url = ''
        const URL = window.URL || window.webkitURL
        if (URL && URL.createObjectURL) {
          newFile.url = URL.createObjectURL(newFile.file)
        }
      }
    },

    getValue() {
      if (
        this.filesWide.length &&
        this.filesWide[0].response !== {} &&
        this.filesWide[0].response.data !== undefined
      ) {
        return this.filesWide[0].response.data[0].uri
      }
      return null
    }
  },

  props: {
    defaultImage: {
      type: String,
      default: () => 'https://www.gravatar.com/avatar/default?s=200&r=pg&d=mm'
    },
    aspectRatio: {
      type: Number,
      default: () => 1264 / 300
    }
  },

  setup(props, { emit }) {
    const authHeaderValue = authHeader()
    const superAdmin = localStorage.getItem('auth_superadmin')
    const editor = localStorage.getItem('auth_editor')

    const apiUrl =
      superAdmin === true || superAdmin === 'true' || editor === true || editor === 'true'
        ? process.env.VUE_APP_BASE_API_URL + '/api/v1/super-admin/cdn/upload'
        : process.env.VUE_APP_BASE_API_URL + '/api/v1/admin/cdn/upload'

    return {
      authHeaderValue,
      apiUrl
    }
  }
})
</script>
